var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',{staticClass:"mainContainer bg-white"},[_c('CRow',{staticStyle:{"margin":"auto"}},[_c('label',{staticClass:"noitem"},[_vm._v("NO DATA !!!")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }